// Captures the user's timezone and (if permitted) coarse geolocation once on mount into the global
// uiContext store, so it can be attached to every agent interaction (text send, push-to-talk,
// interactive session start) via buildAgentContextMeta — from anywhere, no prop threading.
import { useEffect } from 'react';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { setDeviceContext } from '@/redux/slices/uiContextSlice';

export function useUserContext(): void {
  const dispatch = useAppDispatch();
  useEffect(() => {
    try {
      dispatch(setDeviceContext({ timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }));
    } catch { /* unsupported */ }
    if (typeof navigator !== 'undefined' && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => dispatch(setDeviceContext({ latitude: pos.coords.latitude, longitude: pos.coords.longitude })),
        () => { /* permission denied */ },
        { timeout: 8000, maximumAge: 600000 },
      );
    }
  }, [dispatch]);
}
